<template lang="html">
  <div class="prt-loader" :style="{width: `${size}px`, height: `${size}px`}">
    <div class="waveBg" :style="{transitionDuration: `${duration + (duration / 6)}s`, backgroundPosition: dynamicBGPositionBG}" @transitionend="filledUp" />
    <div class="waveFg" :style="{transitionDuration: `${duration}s`, backgroundPosition: dynamicBGPositionFG}" />
    <img alt="anchor" class="anchor" src="../../assets/loader/anchor.svg">
  </div>
</template>

<script>
export default {
  computed: {
    dynamicBGPositionBG() {
      return this.transitionStarted ? '0px 0px' : `${this.size * (this.duration / 6) * 5}px ${this.size * 1.2109375}px`;
    },
    dynamicBGPositionFG() {
      return this.transitionStarted ? `${this.size * (this.duration / 6) * 8}px 0px` : `0px ${this.size * 1.1484375}px`;
    },
  },
  mounted() {
    window.setTimeout(() => { this.transitionStarted = true; }, 100); // FIXME: this is an ugly hack that might break at any time
  },
  data() {
    return {
      transitionEndHandled: false,
      transitionStarted: false,
    };
  },
  methods: {
    filledUp() {
      if (!this.transitionEndHandled) {
        this.transitionEndHandled = true;
        if (!this.infinite) this.$emit('completed');
        else this.transitionStarted = !this.transitionStarted;
        this.$nextTick(() => { this.transitionEndHandled = false; });
      }
    },
  },
  props: {
    duration: Number,
    infinite: Boolean,
    size: {
      type: Number,
      default: 128,
    },
  },
};
</script>

<style lang="stylus">
  @require '../../styles/colors'

  .prt-loader
    overflow: hidden
    width: 128px
    height: 128px
    background-color: white
    border-radius: 50%
    position: relative

    img
      display: block

    .anchor
      height: 70%
      margin: auto
      margin-top: 15%
      position: relative
      z-index: 2

    .waveBg,
    .waveFg
      background-repeat: repeat-x
      background-size: 100%
      background-position: 0px 0px
      width: 100%
      height: 114.375%
      position: absolute
      bottom: 0
      transition: background-position 6s ease-out

    .waveBg
      background-image: url('../../assets/loader/wave_bg.svg');
      transition-duration: 7s

    .waveFg
      background-image: url('../../assets/loader/wave_fg.svg');
</style>
